module.exports = __webpack_public_path__ + "img/docker.cab3a97c.png";